import { SvgIcon, SvgIconProps } from '@mui/material';

export const BarcodeIcon = (props: SvgIconProps) => {
    return <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="2" y="4" width="1" height="16" />
        <rect x="4" y="4" width="2" height="16" />
        <rect x="7" y="4" width="1" height="13" />
        <rect x="9" y="4" width="2" height="13" />
        <rect x="13" y="4" width="3" height="16" />
        <rect x="17" y="4" width="1" height="13" />
        <rect x="19" y="4" width="2" height="16" />
        <rect x="22" y="4" width="1" height="16" />
    </SvgIcon>;
};
